import { Moon, Sun, Laptop } from 'lucide-react'
import { useTheme } from '../theme-context'
import { cn } from '../../lib/utils'

const MODES = [
  { value: 'light', icon: Sun, label: '浅色' },
  { value: 'dark', icon: Moon, label: '深色' },
  { value: 'system', icon: Laptop, label: '跟随系统' },
] as const

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  return (
    <div className="flex items-center bg-secondary p-0.5 rounded-full">
      {MODES.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          className={cn(
            'flex-1 flex items-center justify-center p-2 rounded-full transition-colors',
            theme === value
              ? 'bg-white dark:bg-white/15 text-primary shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
          title={label}
        >
          <Icon className="w-4 h-4" />
        </button>
      ))}
    </div>
  )
}
